import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "user-contacts" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "type-button-04" }
const _hoisted_6 = { class: "type-button-04" }
const _hoisted_7 = {
  key: 0,
  class: "row contact-row"
}
const _hoisted_8 = { class: "contact-name type-button-04" }
const _hoisted_9 = { class: "contact-position type-body-05" }
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactCard = _resolveComponent("ContactCard")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ActionHeader = _resolveComponent("ActionHeader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["grid", { loading: _ctx.isLoading }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsersContacts, (contact, cidx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col sm:col-6 md:col-4 lg:col-6 xl:col-4",
          key: cidx
        }, [
          _createVNode(_component_ContactCard, {
            mode: "edit",
            contact: contact,
            onRemoveContact: _ctx.handleContactRemove,
            onUpdateFilters: _ctx.handleFiltersUpdate
          }, null, 8, ["contact", "onRemoveContact", "onUpdateFilters"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
        _createVNode(_component_Button, {
          text: "contact-groups.contacts.add.new",
          variant: "tertiary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addContacts())),
          block: ""
        }, {
          labelBefore: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "plus" })
          ]),
          _: 1
        })
      ])
    ], 2),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      onCancel: _ctx.hideAddModal,
      onConfirm: _ctx.handleContactAdd,
      onDismiss: _ctx.hideAddModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ActionHeader, {
            actionTitle: 
              _ctx.translateText('contact-groups.contacts.choose.heading')
            ,
            actionDescription: 
              _ctx.translateText('contact-groups.contacts.choose.description')
            
          }, null, 8, ["actionTitle", "actionDescription"]),
          _createVNode(_component_Search, {
            id: "search-user-documents",
            class: "style-standard",
            searchOpen: "",
            onFilterSearch: _ctx.searchContacts
          }, null, 8, ["onFilterSearch"]),
          _createVNode(_component_TableList, {
            tableName: "contacts",
            class: "style-standard"
          }, {
            colspan: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"10%"} }),
                _createElementVNode("col", { style: {"width":"30%"} }),
                _createElementVNode("col", { style: {"width":"50%"} }),
                _createElementVNode("col", { style: {"width":"10%"} })
              ], -1)
            ]))]),
            head: _withCtx(() => [
              _createElementVNode("thead", null, [
                (_ctx.getTableContacts.length > 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                      _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1)),
                      _createElementVNode("th", _hoisted_5, [
                        _createVNode(_component_TranslatedText, { path: "contact-groups.contacts.list.name" })
                      ]),
                      _createElementVNode("th", _hoisted_6, [
                        _createVNode(_component_TranslatedText, { path: "contact-groups.contacts.list.groups" })
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            body: _withCtx(() => [
              _createElementVNode("tbody", null, [
                (_ctx.getTableContacts.length <= 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("td", { colspan: "3" }, "No Contacts to show", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getTableContacts, (contact, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: i,
                        class: _normalizeClass(["row contact-row", {
                      alternate: _ctx.isOdd(i),
                    }])
                      }, [
                        _createElementVNode("td", null, [
                          contact
                            ? (_openBlock(), _createBlock(_component_Avatar, {
                                key: 0,
                                size: "sm",
                                image: contact?.image ? contact.image : false,
                                alt: contact?.name ?? '',
                                text: contact?.name ?? ''
                              }, null, 8, ["image", "alt", "text"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(contact?.name ?? ""), 1),
                          _createElementVNode("p", _hoisted_9, _toDisplayString(contact?.position ?? ""), 1)
                        ]),
                        _createElementVNode("td", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getContactGroups(contact), (group, j) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "contact-groups tag",
                              key: j
                            }, _toDisplayString(group.name), 1))
                          }), 128))
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_Button, {
                            text: "contact-groups.contacts.list.add",
                            onClick: ($event: any) => (_ctx.addContact(contact?.id)),
                            size: "sm",
                            variant: "tertiary",
                            block: ""
                          }, null, 8, ["onClick"])
                        ])
                      ], 2))
                    }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(({ cancel }) => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              text: "common.close",
              onClick: cancel,
              size: "sm",
              variant: "secondary",
              block: ""
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onCancel", "onConfirm", "onDismiss"])
  ]))
}